module.exports = __webpack_public_path__ + "img/hbao1.56050b7c.png";